// Componente que reenvia la campaña del padre a los hijos
export default {
  props: {
    campaign: {type: Object, default: () => ({})}
  },
  render(c) {
    return c('router-view', {props: {campaign: this.campaign}})
  }
}
